import Team from '@/models/Team/team';

export default class Game {
  constructor({
    id = null,
    awayTeam = null,
    homeTeam = null,
    playersScoreUpdatedAt = null,
    updatedAt = null,
    date = null,
    coverage = null,
    status = null,
    isNationalTeamGame = false,
  } = {}) {
    this.id = id;
    this.awayTeam = awayTeam ? Team.createFromObject(awayTeam) : null;
    this.homeTeam = homeTeam ? Team.createFromObject(homeTeam) : null;
    this.date = date ? new Date(date) : null;
    this.coverage = coverage;
    this.status = status;
    this.playersScoreUpdatedAt = playersScoreUpdatedAt ? new Date(playersScoreUpdatedAt) : null;
    this.updatedAt = updatedAt ? new Date(updatedAt) : null;
    this.isNationalTeamGame = isNationalTeamGame;
  }

  static createFromObject(data) {
    return new Game(data);
  }

  static createCollectionFromObject(data, isNationalTeamGame = false) {
    return data.map(
      (gameData) => Game.createFromObject({ ...gameData, isNationalTeamGame }),
    );
  }
}
